import moment, { Moment } from "moment";
import { ISelectedService } from "pages/booking/interface";

export const calStartTimeOfService = (
  selectedServices: Array<ISelectedService>,
  staffId: string,
  date: number,
  idx: number,
  includeBufferTime: boolean
) => {
  let startTime = moment(date * 1000);
  selectedServices.forEach((service, index) => {
    if (index < idx && staffId === service.staffId)
      startTime = moment(startTime).add(
        service.time + (includeBufferTime ? service.bufferTime : 0),
        "minutes"
      );
  });
  return startTime.unix().toString();
};

export const convertToPhoneNumber = (formatNumber: any) => {
  const listChar = formatNumber.split("");
  const newList: any[] = [];
  listChar.forEach((element: any) => {
    const check = parseInt(element);
    if (!isNaN(check)) {
      newList.push(element);
    }
  });

  return newList;
};

export const isValidPhoneNumber = (phoneNumber: string) => {
  const phoneLength = phoneNumber.replace(
    /\s|[-&\/\\#,+()$~%.'":*?<>{}]/g,
    ""
  ).length;
  return phoneLength === 10;
};

export const isValidEmail = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const calcUnixDateTime = (
  date: Moment | undefined,
  time: number,
  timezone: string
) => {
  if (date) {
    const dateStr = moment(date).format("YYYY-MM-DD");
    const dateTimeStr = `${dateStr} ${time}`;
    const dateTime = moment.tz(dateTimeStr, "YYYY-MM-DD hh:mm A", timezone);
    return dateTime.unix();
  }
  return 0;
};

export function convertTo24Hour(time: string, addMinutes = 0) {
  const [timePart, modifier] = time.split(" ");
  let [hours, minutes] = timePart.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  } else if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  let totalMinutes = hours * 60 + minutes + addMinutes;

  hours = Math.floor(totalMinutes / 60) % 24;
  minutes = totalMinutes % 60;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
}
